export const stringArraysAreEqual = (arr1: string[], arr2: string[]) => {
  if (arr1.length !== arr2.length) {
    return false;
  }

  const sortedArr1 = [...arr1].sort();
  const sortedArr2 = [...arr2].sort();

  return sortedArr1.every((value, index) => value === sortedArr2[index]);
}

export const mergeArraysUnique = (arraysToAdd: [number, number][], arrays: [number, number][] = []) => {
  const merged = [...arrays];
  arraysToAdd.forEach(([start, end]) => {
    const index = merged.findIndex(([s, e]) => s === start && e === end);
    if (index === -1) {
      merged.push([start, end]);
    } else {
      merged[index][1] = Math.max(merged[index][1], end);
    }
  });
  return merged;
};
